export type ReadyMetricName = 'overview-primary-ready' | 'access-ready';
export type ReadyOutcome = 'ready' | 'empty' | 'partial' | 'error';
export type NavigationKind = 'document' | 'route' | 'workspace';

export interface PageVisit {
  key: string;
  route: string;
  workspaceId: string | undefined;
  startedAt: number;
  navigation: NavigationKind;
  reported: Set<ReadyMetricName>;
}

/** Keep navigation start and tenant identity with the visit, not the later flush. */
export function nextPageVisit(
  previous: PageVisit | null, key: string, route: string, workspaceId: string | undefined, now: number,
): PageVisit {
  if (previous?.key === key && previous.workspaceId === workspaceId) return previous;
  return {
    key, route, workspaceId,
    startedAt: previous ? now : 0,
    navigation: !previous ? 'document' : previous.workspaceId !== workspaceId ? 'workspace' : 'route',
    reported: new Set(),
  };
}

/** A refetch or remount must not add a second successful sample for one visit. */
export function pageReadySample(visit: PageVisit, name: ReadyMetricName, outcome: ReadyOutcome, now: number) {
  if (visit.reported.has(name)) return null;
  visit.reported.add(name);
  return {
    name, value: Math.max(0, Math.round(now - visit.startedAt)), outcome,
    route: visit.route, workspace_id: visit.workspaceId ?? null, navigation: visit.navigation,
  };
}
